import utils from "../../../utils/utils.js";

export default {
    async fetchFeedList(context, payload) {
        const mainCat = payload.catOptions.mainCat;
        const subCat = payload.catOptions.subCat;
        const detailCat = payload.catOptions.detailCat;

        payload.filter.mainCats.map(item => {
            if (item == null || item == undefined) return item;

            let match = mainCat.find(obj => obj.id === parseInt(item));

            return match ? match.id : item;
        });

        payload.filter.subCats.map(item => {
            if (item == null || item == undefined) return item;

            let match = subCat.find(obj => obj.id === parseInt(item));

            return match ? match.id : item;
        });

        payload.filter.detailCats.map(item => {
            if (item == null || item == undefined) return item;

            let match = detailCat.find(obj => obj.id ===  parseInt(item));

            return match ? match.id : item;
        });

        const paramsObject = {
            page: payload.filter.page,
            sentiments: payload.filter.sentiments,
            keywords: payload.filter.keywords,
            channels: payload.filter.channels,
            sources: payload.filter.sources,
            publishers: payload.filter.publishers,
            types: payload.filter.types,
            langs: payload.filter.langs,
            relatives: payload.filter.relatives,
            mainCats: payload.filter.mainCats,
            subCats: payload.filter.subCats,
            detailCats: payload.filter.detailCats,
            years: payload.filter.years,
            months: payload.filter.months,
            days: payload.filter.days,
            date: payload.filter.date,
            searchText: payload.filter.searchText,
            showRetweets: payload.filter.showRetweets,
            sourceUserId:payload.filter.sourceUserId,
            feedId:payload.filter.feedId,
            sort: payload.filter.sort,
        };

        const params = utils.utility.checkQueryParams(paramsObject);

        const response = await utils.utility.fetch(`api/Editor/Search?${params.toString()}`, "GET", null, null);

        context.commit("setFeedList", response.data.results);
        context.commit("setTotalFeedCount", response.data.numFound);
    },
    async postFeedSentiment(context, payload) {
        await utils.utility.fetch("api/Editor/ChangeSentiment", "PUT", null, { feedId: payload.feedId, sentimentId: payload.sentimentId });
        
        context.commit("setSentiment", payload);
    },
    async fetchFeedTypes(context) {
        const response = await utils.utility.fetch(
          `api/Editor/GetFeedTypes`,
          "GET",
          null,
          null
        );
    
        context.commit("setFeedTypes", response.data);
    },
    async fetchAnswerTypes(context) {
        const response = await utils.utility.fetch(
            `api/Editor/GetAnswerTypes`,
            "GET",
            null,
            null
        );

        context.commit("setAnswerTypes", response.data);
    }
}